// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"c95cce9d","333":"a30d8924","369":"285ed1dd","389":"f479f5ec","671":"d11a5a6f"}[chunkId] + ".chunk.js";
};